import * as angular from "angular";
import { IHttpService, IQService } from "angular";
import { UserManagerSettings, UserManager, User } from "oidc-client"
import { some } from "lodash";

import { buildAuthorizedAppModule } from "./authorized-app.module";
import { buildAnonymousAppModule } from "./anonymous-app.module";

/**
 * Get API Endpoints
 */
export const getEndpoints = () => {
    const bootstrapInjector = angular.injector(["ng"], true);
    const $http = bootstrapInjector.get<IHttpService>("$http");
    const $q = bootstrapInjector.get<IQService>("$q");

    return $q.all([
        $http.get<string>("api/ClientSettings/GetBoardWebAdminEndpoint"),
        $http.get<string>("api/ClientSettings/GetBoardWebEndpoint"),
        $http.get<string>("api/ClientSettings/GetIdpEndpoint")
    ]).then(endPoints => {
        return {
            adminEndpoint: endPoints[0].data,
            webEndpoint: endPoints[1].data,
            idpEndpoint: endPoints[2].data
        };
    });
};

export const buildUserManagers = (adminEndpoint: string, boardWebEndpoint: string, idpEndpoint: string) => {
    const hostEndpoint = process.env.NODE_ENV === "dev" ? "https://localhost:9000" : adminEndpoint;

    const boardWebAdminUserManagerSettings: UserManagerSettings = {
        authority: !idpEndpoint ? `${adminEndpoint}/identity/` : idpEndpoint,
        client_id: "acspa",
        redirect_uri: `${hostEndpoint}/redirect.html`,
        // Add the slient renew redirect URL
        silent_redirect_uri: `${hostEndpoint}/silent-renew.html`,
        post_logout_redirect_uri: !idpEndpoint ? hostEndpoint : `${hostEndpoint}/`,
        response_type: "id_token token",
        scope: !idpEndpoint ? "openid" : "openid profile email admin-tool-api",
        loadUserInfo: true,
        // Add expiration nofitication time
        accessTokenExpiringNotificationTime: 4,
        // Setup to renew token access automatically
        automaticSilentRenew: true,
        filterProtocolClaims: !idpEndpoint
    };

    const boardWebUserManagerSettings: UserManagerSettings = {
        authority: !idpEndpoint ? `${boardWebEndpoint}/identity/` : idpEndpoint,
        client_id: "boardwebapplication",
        loadUserInfo: !!idpEndpoint,
        // Add expiration nofitication time
        accessTokenExpiringNotificationTime: 60,
        // Setup to renew token access automatically
        automaticSilentRenew: true,
        silent_redirect_uri: `${hostEndpoint}/silent-renew.html`,
        response_type: "id_token token",
        scope: !idpEndpoint ? "openid" : "openid profile board-api",
        popup_redirect_uri: `${hostEndpoint}/signin-popup-redirect.html`,
        popup_post_logout_redirect_uri: `${hostEndpoint}/signout-popup-redirect.html`
    };

    return {
        adminUserManager: new UserManager(boardWebAdminUserManagerSettings),
        webUserManager: new UserManager(boardWebUserManagerSettings)
    };
};

// const getUsers = (adminUserManager: Oidc.UserManager, webUserManager: Oidc.UserManager) => {
//     return adminUserManager.getUser().then(webAdminUser => {
//         return webUserManager.getUser().then(webUser => {
//             return {
//                 adminUser: webAdminUser,
//                 webUser: webUser
//             };
//         });
//     });
// };

export const bootstrapAuthorizedApplication = (adminUserManager: UserManager, adminUser: User, webUserManager: UserManager, boardWebEndpoint: string, idpEndpoint: string) => {
    webUserManager.getUser().then(user => {
        angular.bootstrap("body", [buildAuthorizedAppModule(adminUserManager, adminUser, webUserManager, boardWebEndpoint, user, idpEndpoint)], { strictDi: true });
    });
};

export const bootstrapAnonymousApplication = (adminUserManager: UserManager) => {
    angular.bootstrap("body", [buildAnonymousAppModule(adminUserManager)], { strictDi: true });
};

/**
 * Check if the requested path is part of valid anonymous paths
 * @param requestPath
 */
export const anonymousBootstrap = (requestPath: string) => {
    const anonymousPaths = [
        "require-reset-password",
        "reset-password",
        "change-password",
        "complete-profile",
        "register",
        "emailconfirmed"
    ];

    return some(anonymousPaths, path => { return requestPath.indexOf(path) !== -1 });
};


// WEBPACK FOOTER //
// ./app/zbootstrap.ts